import { Swiper, SwiperSlide } from "swiper/react";
import {
	EffectCoverflow,
	Keyboard,
	Mousewheel,
	Pagination,
	Autoplay,
	Navigation,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

const images = [
	{
		topText: "Damanna Law PLLC",
		img: "../assets/images/bat-img/carousel/1.png",
		bottomText: "Geeta Dammanna",
	},
	{
		topText: "Damanna Law PLLC",
		img: "../assets/images/bat-img/carousel/4.png",
		bottomText: "Geeta Dammanna",
	},

	{
		topText: "Damanna Law PLLC",
		img: "../assets/images/bat-img/carousel/5.png",
		bottomText: "Geeta Dammanna",
	},
	{
		topText: "Smart Folks",
		img: "../assets/images/bat-img/carousel/6.png",
		bottomText: "Ram Nandyala",
	},
	{
		topText: "Smart Folks",
		img: "../assets/images/bat-img/carousel/7.png",
		bottomText: "Ram Nandyala",
	},
	{
		topText: "Smart Folks",
		img: "../assets/images/bat-img/carousel/8.png",
		bottomText: "Ram Nandyala",
	},
	{
		topText: "Smart Folks",
		img: "../assets/images/bat-img/carousel/9.jpg",
		bottomText: "Ram Nandyala",
	},

	{
		topText: "Smart Folks",
		img: "../assets/images/bat-img/carousel/10.png",
		bottomText: "Ram Nandyala",
	},
	{
		topText: "Smart Folks",
		img: "../assets/images/bat-img/carousel/11.jpg",
		bottomText: "Ram Nandyala",
	},

	{
		topText: "Smart Folks",
		img: "../assets/images/bat-img/carousel/12.png",
		bottomText: "Ram Nandyala",
	},
	{
		topText: "Smart Folks",
		img: "../assets/images/bat-img/carousel/13.jpg",
		bottomText: "Ram Nandyala",
	},
];

const Carousel = () => {
	return (
		<div className="w-full flex justify-center items-center p-8">
			<Swiper
				effect="coverflow"
				grabCursor={true}
				centeredSlides={true}
				autoplay={{ delay: 100, disableOnInteraction: true }}
				loop={true}
				slidesPerView={1}
				coverflowEffect={{
					rotate: 0,
					stretch: 0,
					depth: 100,
					modifier: 3,
					slideShadows: true,
				}}
				keyboard={{ enabled: true }}
				mousewheel={{ thresholdDelta: 70 }}
				pagination={{ clickable: true }}
				navigation={true}
				breakpoints={{
					640: { slidesPerView: 2 },
					768: { slidesPerView: 1 },
					1024: { slidesPerView: 2 },
					1560: { slidesPerView: 3 },
				}}
				modules={[
					EffectCoverflow,
					Keyboard,
					Mousewheel,
					Pagination,
					Navigation,
				]}
				className="swiper-container"
			>
				{images.map((item, index) => (
					<SwiperSlide key={index}>
						<div className="carousel-card-bg">
							<img src={item?.img} alt="BAT" style={{ width: "300px" }} />
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default Carousel;
